import axiosClient from './axiosClient'

const reportApi = {
  getUsedInvoices: (params, signal) => {
    const url = '/invoice/list-all-report'
    return axiosClient.get(url, { params, signal })
  },

  exportUsedInvoices: (params) => {
    const url = '/invoice/export-excel'
    return axiosClient.get(url, { params, responseType: 'blob' })
  },

  getIssuedInvoice: (params, signal) => {
    const url = '/statistic/get-invoice-template-serial-stats'
    return axiosClient.get(url, { params, signal })
  },

  getDetailInvoices: (params, signal) => {
    const url = '/statistic/get-invoice-stats-detail'
    return axiosClient.get(url, { params, signal })
  },

  exportData: (params) => {
    const url = '/statistic/export-invoice-stats-detail'
    return axiosClient.get(url, { params, responseType: 'blob' })
  },

  getReportBytax: (params, signal) => {
    const url = '/statistic/get-invoice-stats-by-tax'
    return axiosClient.get(url, { params, signal })
  },

  exportInvoiceStatsByTax: (params) => {
    const url = '/statistic/export-invoice-stats-by-tax'
    return axiosClient.get(url, { params, responseType: 'blob' })
  },

  getInvoiceStatFile: (params) => {
    const url = '/statistic/export-invoice-stats-detail'
    return axiosClient.get(url, { params, responseType: 'blob' })
  },

  exportReportFile: (body, params, responseType) => {
    const url = '/statistic/downloadFile'
    if (responseType) {
      return axiosClient.post(url, body, {
        params: params, // Đính kèm params vào URL
        responseType,
      })
    } else {
      return axiosClient.post(url, body, {
        params: params, // Đính kèm params vào URL
      })
    }
  },

  downloadFilePublic: (params) => {
    if (params?.type == 'file') {
      const url = '/fileTemplate/getFileByCode'
      return axiosClient.get(url, { params, responseType: 'blob' })
    } else {
      const url = '/fileTemplate/getFileByCode'
      return axiosClient.get(url, { params })
    }
  },
  getOveralObstetrics: (params, signal) => {
    const url = '/statistic/get-overal-obstetrics'
    return axiosClient.get(url, { params, signal })
  },

  exportTvanReportFile: (params) => {
    const url = '/tvanHandle/exportStatistics'
    return axiosClient.get(url, { params, responseType: 'blob' })
  },

  exportReportInvoiceFile: (body, params, responseType) => {
    const url = '/statistic/downloadInvoiceFile'
    if (responseType) {
      return axiosClient.post(url, body, {
        params: params, // Đính kèm params vào URL
        responseType,
      })
    } else {
      return axiosClient.post(url, body, {
        params: params, // Đính kèm params vào URL
      })
    }
  },
}

export default reportApi
